import { TaxWithholdingValueType } from '@Types'
import { WhenToSendUnion, TransferFrequencyType, TransferRecurrencesType } from '../TransferFrequency/Types'
import { DistributionReasonTypes } from '../../containers/CheckTransfers/Types'
import { TransferFeesType } from '../TransferFees/types'

export interface CashJournalErrors {
  fromAccount?: string
  toAccount?: string
  transferAmount?: string
  distributionReason?: string
  contributionReason?: string
}
export interface CashJournalTouched {
  fromAccount?: boolean
  toAccount?: boolean
  transferAmount?: boolean
  distributionReason?: boolean
  contributionReason?: boolean
}

export type ContributionYear = 'CURRENT' | 'PREVIOUS'
export interface CashJournalValues {
  fromAccount?: string
  toAccount?: string
  amountInput?: string
  transferAmountDisplay: string
  transferAmountRaw: number
  distributionReason?: DistributionReasonTypes
  contributionReason?: string
  contributionType?: string
  totalBalanceCheckbox: boolean
  contributionYear?: ContributionYear
  transferRecurrence?: TransferRecurrencesType
  whenToSend?: WhenToSendUnion
  transferScheduledDate?: Date | string
  transferFrequency?: TransferFrequencyType
  transferStartDate?: Date | string
  numberOfTransfers?: number

  federalTaxWithholdingType?: TaxWithholdingValueType
  federalTaxWithholdingAmountDisplay?: string
  federalTaxWithholdingAmountRaw?: number
  stateTaxWithholdingType?: TaxWithholdingValueType
  stateTaxWithholdingAmountDisplay?: string
  stateTaxWithholdingAmountRaw?: number

  fees: TransferFeesType
  optOutFormProvided?: boolean
}
export interface IAccount {
  accountNumber: string
  accountTitle?: string
  restrictionCode?: string | null
}

export enum JournalVariation {
  indToInd = 'IND-TO-IND',
  indToIra = 'IND-TO-IRA',
  iraToIra = 'IRA-TO-IRA',
  iraToInd = 'IRA-TO-IND',
  incomplete = 'INCOMPLETE'
}

export interface CashJournalData {
  fromAccount: {
    accountNumber: string
    isIRA: boolean
  }
  toAccount: {
    accountNumber: string
    isIRA: boolean
  }
}
